export default "__VITE_ASSET__9hI3ofwE__"